import { RouteConfig } from 'vue-router';

import { MemberRequestContext } from '@views/member/MemberRequestContext';
import SelectPaymentMethod from '@views/split/select';
import { SelectPaymentMethodContext } from '@views/split/select/context';
import useSelectPaymentMethod from '@views/split/select/SelectPaymentMethod';
import SplitPayment from '@views/split/settlement/split';
import useSplitPayment from '@views/split/settlement/split/SplitPayment';
import { SplitPaymentContext } from '@views/split/settlement/split/context';
import OneTimePayment from '@views/split/settlement/one_time';
import { OneTimePaymentContext } from '@views/split/settlement/one_time/context';
import useOneTimePayment from '@views/split/settlement/one_time/OneTimePayment';
import Loading from '@views/loading';
import { LoadingContext } from '@views/loading/context';
import { useLoading } from '@views/loading/splitSettlementLoading';

import AppEmptyRoute from '@berlin-front/common/components/elements/AppEmptyRoute';
import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';
import { ROUTE_NAME } from './route-name';

const atoneSplithRoute: RouteConfig = {
  path: '/atone-split',
  components: {
    default: AppEmptyRoute,
    contextProvider: MemberRequestContext.provider,
  },
  children: [
    {
      // 決済画面。
      path: 'select',
      name: ROUTE_NAME.ATONE_SPLIT_SELECT,
      meta: {
        cancelModalType: 'shopping',
        headerType: HEADER_TYPE.TITLE_ONLY,
        headerTitle: 'お支払い回数を選ぶ',
      },
      components: {
        default: SelectPaymentMethod,
        contextProvider: SelectPaymentMethodContext.provider,
      },
      props: {
        contextProvider: useSelectPaymentMethod,
      },
    },
    {
      path: 'settlement',
      components: {
        default: AppEmptyRoute,
      },
      children: [
        {
          // 分割決済画面
          path: 'split',
          name: ROUTE_NAME.ATONE_SPLIT_SETTLEMENT_SPLIT,
          meta: {
            cancelModalType: 'shopping',
            headerType: HEADER_TYPE.SHOP_TITLE,
            headerTitle: '注文確定',
          },
          components: {
            default: SplitPayment,
            contextProvider: SplitPaymentContext.provider,
          },
          props: {
            contextProvider: useSplitPayment,
          },
        },
        {
          // 一括決済画面
          path: 'one-time',
          name: ROUTE_NAME.ATONE_SPLIT_SETTLEMENT_ONE_TIME,
          meta: {
            cancelModalType: 'shopping',
            headerType: HEADER_TYPE.SHOP_TITLE,
            headerTitle: '注文確定',
          },
          components: {
            default: OneTimePayment,
            contextProvider: OneTimePaymentContext.provider,
          },
          props: {
            contextProvider: useOneTimePayment,
          },
        },
      ],
    },
    {
      // 決済審査中ローディング中画面
      path: 'loading',
      name: ROUTE_NAME.ATONE_SPLIT_LOADING_SETTLEMENT,
      meta: {
        cancelModalType: 'reject',
        headerType: HEADER_TYPE.TITLE_ONLY,
        headerTitle: '注文確定',
      },
      components: {
        default: Loading,
        contextProvider: LoadingContext.provider,
      },
      props: {
        contextProvider: useLoading,
      },
    },
  ],
};

export default atoneSplithRoute;
